/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Evolink_Api_KeyInputs */

const en_admin_settings_fields_evolink_api_key = /** @type {(inputs: Admin_Settings_Fields_Evolink_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

/**
* | output |
* | --- |
* | "API Key" |
*
* @param {Admin_Settings_Fields_Evolink_Api_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_evolink_api_key = /** @type {((inputs?: Admin_Settings_Fields_Evolink_Api_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Evolink_Api_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_evolink_api_key(inputs)
});
export { admin_settings_fields_evolink_api_key as "admin.settings.fields.evolink_api_key" }